import { PreloaderModel } from "../models/PreloaderModel";
import { PreloaderController } from "../controllers/PreloaderController";
import { BaseModule } from "../../../composition/module/BaseModule";
import { PreloaderModuleFlowExecutor } from "./PreloaderModuleFlowExecutor";
import { PreloaderScene } from "../PreloaderScene";

export class PreloaderModule extends BaseModule<void> {

    public override async build(): Promise<void> {
        this.internalContainer.registerSingleton("IPreloaderModel", PreloaderModel);
        this.internalContainer.register("IPreloaderController", PreloaderController);
        this.internalContainer.register(PreloaderScene, PreloaderScene);
        await super.build();
    }

    public async start(): Promise<void> {
        const executor = await this.internalContainer.resolve(PreloaderModuleFlowExecutor);
        await executor.execute(this);
        this.dispose();
    }
}